
riot.tag2('add-fields-edit-block', '  <div class="row">\n    <div class="col-md-12">\n      <ul class="nav nav-tabs m-b-2" if="{value.length &gt; 0}">\n        <li class="{active: activeTab === i}" each="{item, i in value}"><a onclick="{changeTab}"><span>{item.name}</span></a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <add-fields-edit-block-group if="{value.length &gt; 0}" value="{value[activeTab].items || []}"></add-fields-edit-block-group>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;
self.value = [];

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value || [];
    }
});

self.activeTab = 0;

self.changeTab = function (e) {
    self.activeTab = e.item.i;
};

self.on('update', function () {
    if (opts.value) self.value = opts.value;

    if (opts.name) self.root.name = opts.name;
});
});
riot.tag2('add-fields-edit-block-group', '  <div class="row">\n    <form>\n      <div class="col-md-4" each="{field, i in value}" onchange="{change}">\n        <div class="form-group">\n          <label class="control-label">{field.name}</label>\n\n          <input class="form-control" if="{field.type == &quot;string&quot;}" __required="{field.required}" value="{field.value}">\n\n          <textarea class="form-control" if="{field.type == &quot;text&quot;}" __required="{field.required}" rows="5" style="min-width: 100%; max-width: 100%;" value="{field.value}"></textarea>\n\n          <input class="form-control" if="{field.type == &quot;number&quot;}" __required="{field.required}" value="{field.value}" type="{\'number\'}">\n\n          <select class="form-control" if="{field.type == &quot;select&quot;}" __required="{field.required}" value="{field.value}">\n            <option value="">-</option>\n            <option each="{option, k in field.values.split(&quot;,&quot;)}" __selected="{option == field.value}">{option}</option>\n          </select>\n\n          <div class="checkbox" if="{field.type == &quot;checkbox&quot;}" __required="{field.required}" each="{option, k in field.values.split(&quot;,&quot;)}">\n            <label>\n              <input type="checkbox" data-value="{option}" __checked="{field.value.split(&quot;,&quot;).indexOf(option) !== - 1}">{option}\n            </label>\n          </div>\n\n          <div class="radio" if="{field.type == &quot;radio&quot;}" each="{option, k in field.values.split(&quot;,&quot;)}">\n            <label>\n              <input name="{field.name}" type="radio" __checked="{field.value.split(&quot;,&quot;).indexOf(option) !== - 1}" value="{option}">{option}\n            </label>\n          </div>\n\n          <datetime-picker class="form-control" if="{field.type == &quot;date&quot;}" __required="{field.required}" format="YYYY-MM-DD" value="{field.value}"></datetime-picker>\n          <div class="help-block">{field.description}</div>\n        </div>\n      </div>\n    </form>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;

self.change = function (e) {
    e.stopPropagation();
    var type = e.item.field.type;

    if (type !== 'checkbox') {
        e.item.field.value = e.target.value;
    } else {
        var checkedValues = (e.item.field.value || '').split(',');
        var checkedValue = e.target.getAttribute('data-value');
        var idx = checkedValues.indexOf(checkedValue);

        if (idx !== -1) checkedValues.splice(idx, 1);else checkedValues.push(checkedValue);

        e.item.field.value = checkedValues.filter(function (i) {
            return i;
        }).join(',');
    }

    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.parent.root.dispatchEvent(event);
};

self.on('update', function () {
    if (opts.value) self.value = opts.value;
});
});


// WEBPACK FOOTER //
// ./pages/settings/add-fields/add-fields-edit-block.tag